export type EdgeFunctionErrorData = {
  error?: string;
  message?: string;
};

/** Pulls `{ error, message }` out of the `context` of a `supabase.functions.invoke` error. */
export function readEdgeFunctionErrorData(error: unknown): EdgeFunctionErrorData | null {
  const context = (error as { context?: unknown } | null)?.context;
  if (!context) return null;

  if (typeof context === 'string') {
    try {
      return JSON.parse(context) as EdgeFunctionErrorData;
    } catch {
      return { error: context };
    }
  }
  if (typeof context === 'object') {
    if ('body' in context) {
      return (context as { body?: EdgeFunctionErrorData }).body ?? null;
    }
    return context as EdgeFunctionErrorData;
  }
  return null;
}
